import type { Insight } from "@/types/insight";
import { localizePath } from "@/utils/languageRoutes";

export const generateInsightSlug = (value: string | null | undefined, allowKorean = false): string => {
  const normalized = (value || "")
    .toLowerCase()
    .replace(/[’‘']/g, "")
    .replace(/&/g, " and ");

  const pattern = allowKorean ? /[^0-9a-z가-힣]+/g : /[^0-9a-z]+/g;

  return normalized
    .replace(pattern, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 110)
    .replace(/-+$/g, "");
};

export const getInsightSlug = (insight: Pick<Insight, "slug" | "slug_en" | "slug_ko">, language: string): string => {
  if (language === "KO") {
    return insight.slug_ko || insight.slug || insight.slug_en || "";
  }

  return insight.slug_en || insight.slug || insight.slug_ko || "";
};

export const getInsightPath = (insight: Pick<Insight, "slug" | "slug_en" | "slug_ko">, language: string): string => {
  return localizePath(`/insights/${getInsightSlug(insight, language)}`, language);
};

export const getInsightCanonicalPaths = (insight: Pick<Insight, "slug" | "slug_en" | "slug_ko">) => {
  const englishSlug = insight.slug_en || insight.slug || insight.slug_ko || "";
  const koreanSlug = insight.slug_ko || insight.slug || insight.slug_en || "";

  return {
    en: `/en/insights/${englishSlug}`,
    ko: `/ko/insights/${koreanSlug}`,
    xDefault: `/en/insights/${englishSlug}`,
  };
};
